import { createBoard } from './create'
import { deleteBoard } from './delete'
import { readBoards, readBoard } from './read'
import { resourceObject } from './resourceObject'
import { updateBoard } from './update'

export const boards = {
  clientResource: resourceObject,
  create: createBoard,
  delete: deleteBoard,
  readCollection: readBoards,
  readSingle: readBoard,
  update: updateBoard,
}

export * from './queryHelpers'
